<template>
  <div>
    <el-dialog
      title="个性唛头制作（电信）"
      :visible="isShow"
      width="90%"
      :before-close="handleClose"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-main
        v-if="isLoading"
        v-loading="isLoading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      />
      <template v-else>
        <el-row>
          <el-upload
            action=""
            :show-file-list="false"
            :multiple="false"
            accept=".pdf"
            :before-upload="beforeUploadPurchaseOrder"
            :http-request="uploadPurchaseOrder"
          >
            <el-button type="primary">上传采购单</el-button>
          </el-upload>
        </el-row>
        <el-row>
          <div class="caigou-name">
            <div class="caigou-name__input-wrap">
              <el-input
                ref="headerInput"
                v-model.trim="headerObj.defaultValue"
                :class="{ 'is-error': !!headerError }"
                @input="handleHeaderInput"
              />
              <div v-if="headerError" class="caigou-name__error">{{ headerError }}</div>
            </div>
            <span style="margin-top: 4px;">产品外部装箱单</span>
          </div>
        </el-row>
        <el-row>
          <h4>装箱信息</h4>
          <el-form
            ref="formData"
            :inline="false"
            :model="formData"
            label-width="190px"
          >
            <el-col
              v-for="(item, index) in baseMessageList"
              :key="index"
              :span="item.colSpan"
            >
              <el-form-item
                :label="`${item.fieldDisplayName}：`"
                :prop="item.fieldKey"
                :rules="[
                  {
                    required: item.attributeType === '输入框' && item.isRequired,
                    message: `${item.fieldDisplayName}不能为空`,
                    trigger: ['blur', 'change']
                  },
                  {
                    max: formMaxLength[item.fieldKey] || 50,
                    message: `${item.fieldDisplayName}最多输入${formMaxLength[item.fieldKey] || 50}字`,
                    trigger: ['blur', 'change']
                  }
                ]"
                :label-width="item.fieldKey === 'stockUpOrderNum' ? '240px' : ''"
              >
                <el-input
                  v-if="item.attributeType === '输入框'"
                  v-model.trim="formData[item.fieldKey]"
                  placeholder="请输入"
                />
                <p v-else>
                  {{ formData[item.fieldKey] }}
                </p>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <div class="base-button">
          <h4>产品信息</h4>
          <el-upload
            action=""
            :show-file-list="false"
            :multiple="false"
            accept=".xls,.xlsx"
            :before-upload="beforeUploadBaseData"
            :http-request="uploadBaseData"
          >
            <el-button type="primary">上传基础数据</el-button>
          </el-upload>
        </div>
        <el-table
          ref="tableDataRef"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column fixed label="序号" align="left" type="index" />
          <el-table-column
            v-for="(item, index) in productHeaderList"
            :key="index"
            :prop="item.fieldKey"
            :label="item.fieldDisplayName"
            align="left"
            :width="tableInnerWidth[item.fieldKey] || 160"
            :render-header="(h, obj) => renderHeader(h, obj, item)"
          >
            <template slot-scope="scope">
              <template v-if="item.attributeType === '输入框'">
                <el-input
                  v-if="item.fieldType === 'string'"
                  v-model.trim="scope.row[item.fieldKey]"
                  placeholder="请输入"
                />
                <el-date-picker
                  v-else-if="item.fieldType === 'date'"
                  v-model="scope.row[item.fieldKey]"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%;"
                  value-format="yyyy-MM-dd"
                />
                <el-input-number
                  v-else-if="item.fieldType === 'number'"
                  v-model="scope.row[item.fieldKey]"
                  :min="0"
                  :controls="false"
                  placeholder="请输入"
                  style="width: 100%;"
                />
              </template>
              <span v-else>
                {{ scope.row[item.fieldKey] }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="isSubmitLoading" @click="handleConfirm">确认</el-button>
      </template>
    </el-dialog>

    <RecognizingDialog
      :visible.sync="recognizingVisible"
      :min-wait-seconds="60"
    />
  </div>
</template>

<script>
import { makeMarksViewTemplate, parseMarkPurchaseOrderFile, parseMarkBaseDataFile, attachmentGetToken, markMakeMark } from '@/API';
import AxiosApi from '@/API/fileAxios';
import RecognizingDialog from '@/components/RecognizingDialog.vue';
export default {
  components: { RecognizingDialog },
  data () {
    return {
      isShow: false,
      isLoading: false,
      recognizingVisible: false,
      isSubmitLoading: false,
      paramsIds: {},
      caigouName: '',
      markInfoNum: '',
      formData: {},
      patter: /[`~!@#$%^&*()_+=<>?:"{}|,.;'[\]·~！@#￥%……&*（）——+={}|《》？：“”【】、；‘’，。、]/g,
      headerObj: {},
      headerError: '',
      baseMessageList: [], // 基础信息
      productHeaderList: [], // 产品信息Table头数据
      tableData: [], // 产品信息数据
      token: '',
      uploadUrl: '',
      downFileUrl: '',
      formMaxLength: {
        supplyUnitName: 200,
        orderUnitName: 200,
        supplyUnitPhone: 30,
        orderUnitPhone: 30,
        procurementProjectName: 300,
        deliveryAddress: 300,
        stockUpOrderNum: 50
      },
      tableInnerWidth: {
        goodsName: 170,
        goodsCode: 150,
        productModel: 120,
        materialNumber: 120,
        productName: 140,
        purchaseQuantity: 120,
        packingGrossWeight: 120,
        packingMeasurements: 120,
        productionTime: 180,
        deliveryTime: 160,
        printPaperNumber: 140,
        printBoxNumber: 100
      }
    };
  },
  mounted () {
    this.initToken();
  },
  methods: {
    handleHeaderInput (val) {
      if (typeof val !== 'string') return;
      if (this.headerError) this.headerError = '';
      if (val.length > 200) {
        this.headerError = '产品外部装箱单最多输入200字';
        this.headerObj.defaultValue = val.slice(0, 200);
      }
    },
    handleClose () {
      this.isShow = false;
      this.baseMessageList = [];
      this.productHeaderList = [];
      this.tableData = [];
      this.headerError = '';
    },
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      });
    },
    beforeUploadPurchaseOrder (file) {
      const name = (file && file.name) || '';
      const isPdf = /\.pdf$/i.test(name) || (file && file.type === 'application/pdf');
      if (!isPdf) {
        this.$message.warning('采购单仅支持PDF文件');
        return false;
      }

      const maxSize = 20 * 1024 * 1024; // 20MB
      const fileSize = (file && file.size) || 0;
      if (fileSize > maxSize) {
        this.$message.warning('采购单文件大小不能超过20MB');
        return false;
      }
      return true;
    },
    beforeUploadBaseData (file) {
      const name = (file && file.name) || '';
      const isExcel = /\.(xls|xlsx)$/i.test(name);
      if (!isExcel) {
        this.$message.warning('基础数据仅支持Excel文件（.xls/.xlsx）');
        return false;
      }
      const maxSize = 20 * 1024 * 1024; // 20MB
      const fileSize = (file && file.size) || 0;
      if (fileSize > maxSize) {
        this.$message.warning('基础数据文件大小不能超过20MB');
        return false;
      }
      return true;
    },
    async uploadPurchaseOrder (upload) {
      const file = upload && upload.file;
      if (!file) return;

      this.recognizingVisible = true;
      const form = new FormData();
      form.append('file', file);

      AxiosApi.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(async (res) => {
        const json = res.data;
        if (json.status === '200') {
          const fileParams = {
            'fileId': json.data[0].FID,
            'fileName': json.data[0].FullName,
            'fileType': 'pdf'
          };
          const fileResult = await parseMarkPurchaseOrderFile(fileParams);
          const fileJson = fileResult && fileResult.data;
          if (fileJson && fileJson.status === '200') {
            const fileData = (fileJson && fileJson.data) || {};
            this.headerObj.defaultValue = (fileData[this.headerObj.fieldKey] || '').slice(0, 200);
            this.headerError = '';
            Object.keys(this.formData).forEach(key => {
              if (fileData[key] !== undefined) {
                this.formData[key] = fileData[key];
              }
            });
            this.recognizingVisible = false;
          } else {
            this.recognizingVisible = false;
          }
        }
      }).catch(() => {
        this.recognizingVisible = false;
      });
    },
    async uploadBaseData (upload) {
      const file = upload && upload.file;
      if (!file) return;

      this.recognizingVisible = true;
      const form = new FormData();
      form.append('file', file);
      const _markProductList = this.tableData;
      form.append('markProductList', JSON.stringify({ markProductList: _markProductList }));

      try {
        const res = await parseMarkBaseDataFile(form);
        const json = res && res.data;
        if (json && json.status === '200') {
          const result = (json && json.data) || {};
          this.tableData = [...result];
          this.headerObj.defaultValue = ((result[0] && result[0][this.headerObj.fieldKey]) || '').slice(0, 200);
          this.headerError = '';
        }
      } catch (e) {
        this.$message.error('基础数据识别失败，请稍后重试');
      } finally {
        this.recognizingVisible = false;
      }
    },
    validateUndefined (value) {
      return value === undefined || value === null || value === '';
    },
    async handleConfirm () {
      const baseForm = {};
      // 采购单名称
      if (this.validateUndefined(this.headerObj.defaultValue)) {
        this.headerError = `${this.headerObj.fieldDisplayName}不能为空`;
        this.$nextTick(() => {
          const inputRef = this.$refs.headerInput;
          if (inputRef && typeof inputRef.focus === 'function') inputRef.focus();
        });
        return;
      }
      this.headerError = '';
      baseForm[`markField${this.headerObj.fieldOrder}`] = this.headerObj.defaultValue;
      // formData 基础信息验证
      await this.$refs.formData.validate();
      this.baseMessageList.forEach(item => {
        baseForm[`markField${item.fieldOrder}`] = this.formData[item.fieldKey];
      });
      // tableData 产品信息验证
      const productValid = [];
      this.productHeaderList.forEach(item => {
        if (item.isRequired) {
          productValid.push(item.fieldKey);
        }
        this.tableData.forEach(val => {
          Object.keys(val).forEach(key => {
            if (item.fieldKey === key) {
              val[`markProductField${item.fieldOrder}`] = val[key];
            }
          });
        });
      });

      const productRequiredStatus = [];
      const productInfoList = this.tableData.map(val => {
        productValid.forEach(item => {
          val[item] ? productRequiredStatus.push(1) : productRequiredStatus.push(0);
        });

        let obj = {};
        Object.keys(val).forEach(key => {
          if (key.includes('markProductField')) {
            obj[key] = val[key];
          }
        });
        obj['markProductField20'] = val['packingQuantity'];
        // 产品行需要补充的key集合
        let addKeyList = ['itemIndex', 'plmMarkBoxTotal', 'lastBoxTotal'];
        addKeyList.forEach(key => {
          obj[key] = val[key];
        });
        return obj;
      });
      if (!productRequiredStatus.every(item => item)) return this.$message.error('产品信息必填项请输入完成');

      // 整理数据
      const params = {
        markInfoNum: this.markInfoNum, // 唛头单据编号
        markTemplateId: this.paramsIds.id, // 唛头模版Id
        markInfoId: this.paramsIds.markInfoId, // 唛头id
        partialId: this.paramsIds.partialId, // 发货列表id
        baseInformation: {
          ...baseForm,
          markInformationId: null
        },
        productInformation: productInfoList.map(i => {
          return {
            ...i
          };
        })
      };
      console.log('提交的数据：', params);

      this.isSubmitLoading = true;
      markMakeMark(params).then(res => {
        const { status } = res.data;
        this.isSubmitLoading = false;
        if (status === '200') {
          this.$emit('setData');
          this.handleClose();
          this.$message.success('提交成功');
        }
      }).catch(() => {
        this.isSubmitLoading = false;
      });
    },
    initData (params) {
      makeMarksViewTemplate(params).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          // 基础信息的处理
          const _baseMessageList = (data.baseMessageList || []).map(item => {
            this.$set(this.formData, item.fieldKey, item.defaultValue);
            return {
              ...item,
              colSpan: 8
            };
          });
          this.headerObj = { ..._baseMessageList[0] || {} };
          this.baseMessageList = _baseMessageList.splice(1);
          this.productHeaderList = (data.productHeaderList || []);
          this.tableData = (data.productDefaultValueList || []);
          this.markInfoNum = data.markInfoNum;
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.handleClose();
        }
      }).catch(error => {
        console.error('唛头模板数据获取失败：', error);
        this.isLoading = false;
      });
    },
    // 表头增加必填*符号
    renderHeader (h, { column }, item) {
      if (!item.isRequired) return column.label;
      return [
        h('span', { style: 'color: #f56c6c' }, '*'),
        h('span', ' ' + column.label)
      ];
    },
    openDialog (params) {
      this.paramsIds = params;
      this.isShow = true;
      this.isLoading = true;
      this.initData(params);
    }
  }
};
</script>

<style lang="scss" scoped>
.caigou-name{
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 16px;
}
.caigou-name__input-wrap{
  position: relative;
  width: 300px;
  margin-right: 8px;
}
.caigou-name{
  ::v-deep(.el-input.is-error .el-input__inner){
    border-color: #F56C6C;
  }
  ::v-deep(.el-input.is-error .el-input__inner:focus){
    border-color: #F56C6C;
    box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.2);
  }
}
.caigou-name__error{
  position: absolute;
  left: 0;
  top: calc(100% + 4px);
  width: 100%;
  color: #F56C6C;
  font-size: 12px;
  line-height: 1;
  text-align: left;
}
::v-deep(.el-dialog__body) {
  max-height: 90vh;
  overflow-y: auto;
}
.base-button{
  display: flex;
  align-items: center;
  .el-button{
    margin-left: 12px;
  }
}
</style>
